export default __webpack_public_path__ + "static/media/mintMobileBg.3f3dc105.jpg";